angular.module('ngApp')
  .controller('pagesHeaderComponentController', ['$scope', '$filter', function ($scope, $filter) {
    $scope.title = $filter('trans')($scope.attrs.title);
    $scope.subTitle = $scope.attrs.subtitle ? $filter('trans')($scope.attrs.subtitle) : null;
    $scope.img = $scope.attrs.img;
    $scope.background = $scope.attrs.background;
  }])
